<template>
  <div class="animated fadeIn">
    <!--<b-card no-body bg-variant="dark" text-variant="white" :to="item.url" class="p-4" tag="a">-->
      <!--<i :class="['fal',item.icon,'font-5xl']"></i>-->
      <!--<div class="pt-3 font-weight-bold text-uppercase"><span>{{item.name}}</span></div>-->
    <!--</b-card>-->
    <b-button variant="dark" class="p-4 mb-4" :to="item.url" block>
      <i :class="['fal',item.icon,'font-5xl']"></i>
      <div class="pt-3 font-weight-bold text-uppercase"><span>{{item.name}}</span></div>
    </b-button>
  </div>
</template>

<script>
  export default {
    name: "DashboardTile",
    props: ["item"],
  }
</script>
